import React, { useEffect, useState } from "react";
import UpcomingLeaves from "../../components/MySpace/AllLeaves/UpcomingLeaves";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import {
  ApplyLeaveDate,
  ApplyLeaveFormType,
  DeleteUpcomingLeavePayload,
  LeaveAndWFHListPayloadType,
  SingleApplyPayload,
} from "../../commonTypes/stcoToolsType";
import {
  applyLeaveOrWHFAction,
  deleteUpcomingLeave,
  getLeaveAndWFHListAction,
  getSingleLeaveAction,
  getUpcomingListAction,
  resetSingleLeaveAndWFHApplyData,
  resetStcoToolsError,
  resetStcoToolsMessage,
  resetStcoToolsStatusCode,
  resetStcoToolsSuccess,
  resetUpcomingLeaveList,
  updateApplyLeaveOrWHFAction,
} from "../../redux/stcoTools";
import {
  LeaveAndUpcomingHistoryListType,
  LeaveStatus,
  SingleWFHLeaveApplyDataType,
  WorkFromHomeStatus,
} from "../../redux/stcoTools/stcoToolsType";
import { LEAVE_HISTORYT_HEADERS } from "../../constant/tableHeadersConstants/stcoTools/leaveAndWFHTableHeader";
import LeavesHistoryTable from "../../components/MySpace/AllLeaves/WFHAndLeavesHistoryTable/WFHAndLeavesHistoryTable";
import ApplyLeaveModal from "../../components/MySpace/AllLeaves/ApplyLeaveModal";
import { GetAllFinacUserPayloadType } from "../../commonTypes/authTypes";
import { getAllFinacUsersAction, resetSession } from "../../redux/auth";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../components/commons";
import { LoginResponseType } from "../../redux/auth/authTypes";
import toast, { Toaster } from "react-hot-toast";
import BoxLoader from "../../components/commons/BoxLoader/BoxLoader";
import DeleteUpcomingLeaves from "../../components/MySpace/AllLeaves/DeleteUpcomingLeaves";
import {
  currentDate,
  formatDate,
  getDatesInRange,
  reverseDate,
} from "../../utils/commonFunctions";
import { useLocation } from "react-router-dom";
import { SelctOptionType } from "../../components/DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
import WFHandLeavesHistory from "../../components/MySpace/AllLeaves/WFHandLeavesHistory";
import ViewSingleLeaveAndWFHDeatils from "../../components/MySpace/ViewSingleLeaveAndWFHDeatils";
import CurrentYearLeavesAndWFHStatus from "../../components/MySpace/AllLeaves/CurrentYearLeavesAndWFHStatus";
import { useMenuCheck } from "../../customHooks/useMenuCheck";

type AppProps = {
  token: string | null;
  dispatchLeaveAndWFHHistoryListAction: (
    data: LeaveAndWFHListPayloadType
  ) => void;
  dispatchUpcomingLeaveListAction: (data: LeaveAndWFHListPayloadType) => void;
  leaveAndWFHHistoryList: [] | LeaveAndUpcomingHistoryListType[];
  singleLeaveApply: SingleWFHLeaveApplyDataType;
  upcomingList: [] | LeaveAndUpcomingHistoryListType[];
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchApplyLeaveOrWHFAction: (data: ApplyLeaveFormType) => void;
  dispatchUpdateLeaveOrWHFAction: (data: ApplyLeaveFormType) => void;
  dispatchResetSession: () => void;

  dispatchResetStcoToolsSuccess: () => void;
  dispatchResetStcoToolsError: () => void;
  dispatchResetStcoToolsMessage: () => void;
  dispatchResetStcoToolsStatusCode: () => void;
  userFetching: boolean;
  fetching: boolean;
  success: number | null;
  error: string | null;
  message: string | null;
  statusCode: number | null;
  authFetching: boolean;
  authSuccess: number | null;
  authError: string | null;
  authStatusCode: number | null;
  allFinacUsersList: any;
  loginData: LoginResponseType;
  dispatchResetUpcomingLeaveAndWFHList: () => void;
  dispatchSingleWFHAndLeaveAction: (data: SingleApplyPayload) => void;
  history: any;
  dispatchDeleteUpcomingLeave: (data: DeleteUpcomingLeavePayload) => void;
  dispatchResetSingleLeaveAndWFHApplyData: () => void;
  leaveStatus: LeaveStatus;
  workFromHomeStatus: WorkFromHomeStatus;
};

const AllLeavesAndWHF = ({
  dispatchLeaveAndWFHHistoryListAction,
  dispatchUpcomingLeaveListAction,
  token,
  leaveAndWFHHistoryList,
  upcomingList,
  allFinacUsersList,
  dispatchApplyLeaveOrWHFAction,
  success,
  error,
  statusCode,
  authFetching,
  authSuccess,
  authError,
  authStatusCode,
  dispatchResetSession,
  dispatchResetStcoToolsSuccess,
  dispatchResetStcoToolsError,
  dispatchResetStcoToolsMessage,
  dispatchResetStcoToolsStatusCode,
  loginData,
  fetching,
  message,
  dispatchResetUpcomingLeaveAndWFHList,
  dispatchSingleWFHAndLeaveAction,
  singleLeaveApply,
  history,
  dispatchDeleteUpcomingLeave,
  dispatchUpdateLeaveOrWHFAction,
  dispatchResetSingleLeaveAndWFHApplyData,
  leaveStatus,
  workFromHomeStatus,
}: AppProps) => {
  const defaultTeamMembersString =
    process.env.REACT_APP_DEFAULT_ACCESS_TEAMS_MEMBERS || "[]";
  const defaultUsers: SelctOptionType[] = JSON.parse(
    defaultTeamMembersString
  ) as SelctOptionType[];
  const defaultTeamMembersIds: any[] | [] = defaultUsers
    ?.map((ids) => ids?.value)
    ?.slice(3, 5);
  const pathName = useLocation();
  const search = useLocation().search;
  const redirectId = new URLSearchParams(search).get("redirect_id");
  const isRedirect = redirectId ? true : false;
  let isRedirectId: any = redirectId;
  const notificationId = new URLSearchParams(search).get("notification_id");

  const userProfileAllData =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.userProfileAllData;
  const isModal =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.isModal;
  let isType =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.isType;
  const [isTypeChange, setIsTypeChange] = useState(isType || "");
  const [applyLeaveForm, setApplyLeaveForm] = useState<ApplyLeaveFormType>({
    _id: "",
    user_id: null,
    start_date: "",
    end_date: "",
    type: 1,
    leave_type: "Casual Leave",
    approved_by: {
      label: "select",
      value: null,
    },
    people_to_notify: defaultTeamMembersIds,
    reason: "",
    file_attachment: [],
    leave: [],
    total_days: 0,
    request_status: null,
  });

  const [applyLeaveToggle, setApplyLeaveToggle] = useState(isModal || false);
  const [isEdit, setIsEdit] = useState(false);
  const [isApplyWFHApplyPresent, setIsApplyWFHApplyPresent] = useMenuCheck();
  const [activeAction, setActiveAction] = useState("leave");
  const [deleteLeaveToggle, setDeleteLeaveToggle] = useState(false);
  const [isDeleteData, setIsDeleteData] = useState({
    start_date: "",
    end_date: "",
    day: "",
    id: "",
  });

  const [isDrawerOpen, setIsDrawerOpen] = useState(isRedirect ? true : false);
  const [singleLeaveId, setSingleLeaveId] = useState("");

  const [dateValidation, setDateValidation] = useState<any[]>([]);

  useEffect(() => {
    setIsApplyWFHApplyPresent("Apply WFH Balance", "menu");
    window.scrollTo(0, 0);
    dispatchResetStcoToolsSuccess();
    dispatchResetStcoToolsMessage();
    dispatchResetStcoToolsStatusCode();
    dispatchResetUpcomingLeaveAndWFHList();
    dispatchResetSingleLeaveAndWFHApplyData();
  }, []);

  useEffect(() => {
    if (notificationId) {
      const scrollHeight = document.documentElement.scrollHeight;
      const scrollPosition = scrollHeight * 0.3;

      // Scroll to the calculated position
      window.scrollTo({
        top: scrollPosition,
        left: 0,
        behavior: "smooth", // Optional: Adds smooth scrolling
      });
    }
  }, [notificationId]);

  useEffect(() => {
    if (upcomingList?.length || leaveAndWFHHistoryList?.length) {
      let removeRejectLeave = leaveAndWFHHistoryList?.length
        ? leaveAndWFHHistoryList?.filter(
            (el: LeaveAndUpcomingHistoryListType) => {
              return el?.request_status !== 2;
            }
          )
        : [];

      let allData: LeaveAndUpcomingHistoryListType[] | [] = [
        ...removeRejectLeave,
        ...upcomingList,
      ];

      if (allData?.length > 0) {
        let mergeDate: any[] = allData.flatMap(
          (el: LeaveAndUpcomingHistoryListType) =>
            el.details.map((elm: any) => reverseDate(elm.date))
        );

        mergeDate.sort();
        mergeDate.map((elm: any) => formatDate(elm.date));
        setDateValidation(mergeDate);
      } else {
        setDateValidation([]);
      }
    }
    if (upcomingList?.length === 0 && leaveAndWFHHistoryList?.length === 0) {
      setDateValidation([]);
    }
  }, [leaveAndWFHHistoryList, upcomingList, applyLeaveToggle, isTypeChange]);

  useEffect(() => {
    if (!deleteLeaveToggle) {
      setIsDeleteData({
        start_date: "",
        end_date: "",
        day: "",
        id: "",
      });
    }
  }, [deleteLeaveToggle]);

  useEffect(() => {
    if (singleLeaveApply && Object.keys(singleLeaveApply)?.length) {
      let peopleToNotifyArray = singleLeaveApply?.people_to_notify?.map(
        (el: any) => {
          return el?.user_id;
        }
      );

      setApplyLeaveForm((prv: ApplyLeaveFormType) => {
        return {
          _id: singleLeaveApply?._id,
          user_id: null,
          start_date: singleLeaveApply?.start_date,
          end_date: singleLeaveApply?.end_date,
          leave_type: "Casual Leave",
          type: singleLeaveApply?.type,
          approved_by: {
            label: `${
              singleLeaveApply?.approved_by?.first_name
                ? singleLeaveApply?.approved_by?.first_name
                : ""
            } ${
              singleLeaveApply?.approved_by?.last_name
                ? singleLeaveApply?.approved_by?.last_name
                : ""
            }`,
            value: singleLeaveApply?.approved_by?.user_id,
          },
          people_to_notify: peopleToNotifyArray,
          reason: singleLeaveApply?.reason,
          file_attachment: singleLeaveApply?.file_attachment,
          leave: singleLeaveApply?.details,
          total_days: singleLeaveApply?.total_days,
          request_status: 1,
        };
      });
      ///if same leaves edit
      let removeFromDate = getDatesInRange(
        new Date(reverseDate(singleLeaveApply?.start_date)),
        new Date(reverseDate(singleLeaveApply?.end_date)),
        userProfileAllData?.hr_settings?.working_days
      );

      if (dateValidation?.length) {
        let datesToRemoveFormatted = removeFromDate.map((date: string) => {
          let [day, month, year] = date.split("-");
          return `${year}-${month}-${day}`;
        });

        let originalDatesFiltered = dateValidation.filter(
          (date: string) => !datesToRemoveFormatted.includes(date)
        );

        setDateValidation(originalDatesFiltered);
      }
    } else {
      setApplyLeaveForm((prv: ApplyLeaveFormType) => {
        return {
          ...prv,
          _id: "",
          start_date: "",
          end_date: "",
          leave_type: "Casual Leave",
          approved_by: {
            label: "select",
            value: null,
          },
          people_to_notify: defaultTeamMembersIds,
          reason: "",
          file_attachment: [],
          leave: [],
        };
      });
    }
  }, [singleLeaveApply]);

  useEffect(() => {
    if (loginData?.user_id) {
      setApplyLeaveForm((prv: ApplyLeaveFormType) => {
        return {
          ...prv,
          user_id: loginData?.user_id,
        };
      });
    }
  }, [loginData]);

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        user_type: "employee",
        status: "2,3",
        isPageSeen: notificationId ? true : false,
        redirectNotificationId: notificationId ? notificationId : "",
      };
      dispatchLeaveAndWFHHistoryListAction(finalData);
    }

    if (token) {
      let finalData = {
        token,
        user_type: "employee",
        status: "1,3",
      };
      dispatchUpcomingLeaveListAction(finalData);
    }
  }, []);

  useEffect(() => {
    if (!applyLeaveToggle) {
      setApplyLeaveForm((prv: ApplyLeaveFormType) => {
        return {
          ...prv,
          _id: "",
          start_date: "",
          end_date: "",
          leave_type: "Casual Leave",
          approved_by: {
            label: "select",
            value: null,
          },
          people_to_notify: defaultTeamMembersIds,
          reason: "",
          file_attachment: [],
          leave: [],
        };
      });
      setIsEdit(false);
    }
  }, [applyLeaveToggle]);

  const handleApplyLeave = (data?: string) => {
    if (data) {
      setIsTypeChange(data);
    }
    dispatchResetSingleLeaveAndWFHApplyData();
    setApplyLeaveToggle(!applyLeaveToggle);
  };

  const handleSubmitApplyOrWHF = () => {
    let finalObj = JSON.parse(JSON.stringify(applyLeaveForm));
    finalObj?.leave?.forEach((el: ApplyLeaveDate) => {
      if (el["duration"] === "Full Day") {
        el.duration = 1;
      } else if (el["duration"] === "First Half") {
        el["duration"] = 0.5;
      } else if (el["duration"] === "Second Half") {
        el["duration"] = 0.5;
      }
    });
    let totalCount = 0;
    finalObj?.leave?.forEach((el: ApplyLeaveDate) => {
      totalCount += +el?.duration;
    });
    const casualLeavePresent = finalObj?.leave?.find(
      (leave: ApplyLeaveDate) => leave.leave_type === "Casual Leave"
    );
    const unpaidLeavePresent = finalObj?.leave?.find(
      (leave: ApplyLeaveDate) => leave.leave_type === "Unpaid Leave(full time)"
    );

    finalObj = {
      ...finalObj,
      total_days: totalCount,
      leave_type:
        finalObj?.type === 2
          ? "WFH"
          : userProfileAllData?.hr_settings?.employment_status === "Intern" ||
            userProfileAllData?.hr_settings?.employment_status ===
              "Probation" ||
            userProfileAllData?.hr_settings?.employment_status ===
              "Part Time" ||
            userProfileAllData?.hr_settings?.employment_status === ""
          ? // ||!userProfileAllData?.hr_settings?.leave_balance
            "Unpaid Leave"
          : // : leaveStatus?.balance_leave -
          //     (leaveStatus?.approved_leave +
          //       leaveStatus?.pending_leave -
          //       (isEdit ? leaveStatus?.pending_leave : 0)) <=
          //   0
          !casualLeavePresent
          ? "Full time(Unpaid Leave)"
          : unpaidLeavePresent
          ? "Casual leave(Unpaid Leave)"
          : "Casual Leave",
    };
    localStorage.setItem(
      "leaveApproveBy",
      String(applyLeaveForm?.approved_by?.value)
    );
    if (!isEdit) {
      if (token) {
        let finalData = {
          token: token,
          ...finalObj,
          user_id: loginData?.user_id,
        };
        dispatchApplyLeaveOrWHFAction(finalData);
      }
    } else {
      if (token) {
        let finalData = {
          token: token,
          ...finalObj,
          user_id: loginData?.user_id,
        };
        dispatchUpdateLeaveOrWHFAction(finalData);
      }
    }
    setApplyLeaveToggle(!applyLeaveToggle);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetStcoToolsError();
            }}
          />
        );
      }
    } else if (success === 1) {
      if (message && message === "Leave request has been sent successfully.") {
        toast.success("Leave request has been sent successfully.", {
          duration: 3000,
        });
        dispatchResetStcoToolsSuccess();
        dispatchResetStcoToolsMessage();

        if (token) {
          dispatchResetUpcomingLeaveAndWFHList();
          let finalData = {
            token,
            user_type: "employee",
            status: "1,3",
          };
          dispatchUpcomingLeaveListAction(finalData);
        }
      }
      if (
        message &&
        message === "Work from home request has been sent successfully."
      ) {
        toast.success("WFH request has been sent successfully.", {
          duration: 3000,
        });
        dispatchResetStcoToolsSuccess();
        dispatchResetStcoToolsMessage();

        if (token) {
          dispatchResetUpcomingLeaveAndWFHList();
          let finalData = {
            token,
            user_type: "employee",
            status: "1,3",
          };
          dispatchUpcomingLeaveListAction(finalData);
        }
      }
      if (
        message &&
        message === "Employee availability data has been deleted successfully!"
      ) {
        toast.success("Your leave has been successfully deleted!", {
          duration: 3000,
        });
        dispatchResetStcoToolsSuccess();
        dispatchResetStcoToolsMessage();

        if (token) {
          dispatchResetUpcomingLeaveAndWFHList();
          let finalData = {
            token,
            user_type: "employee",
            status: "1,3",
          };
          dispatchUpcomingLeaveListAction(finalData);
        }
        if (token) {
          dispatchResetUpcomingLeaveAndWFHList();
          let finalData = {
            token,
            user_type: "employee",
            status: "2,3",
            isPageSeen: notificationId ? true : false,
            redirectNotificationId: notificationId ? notificationId : "",
          };
          dispatchLeaveAndWFHHistoryListAction(finalData);
        }
      }
      if (
        (message &&
          message === "Leave request have been updated successfully!") ||
        (message &&
          message === "Work from home request have been updated successfully!")
      ) {
        if (
          message &&
          message === "Leave request have been updated successfully!"
        ) {
          toast.success("Leave request have been updated successfully!", {
            duration: 3000,
          });
        } else {
          toast.success(
            "Work from home request have been updated successfully!",
            {
              duration: 3000,
            }
          );
        }
        dispatchResetStcoToolsSuccess();
        dispatchResetStcoToolsMessage();

        if (token) {
          dispatchResetUpcomingLeaveAndWFHList();
          let finalData = {
            token,
            user_type: "employee",
            status: "1,3",
          };
          dispatchUpcomingLeaveListAction(finalData);
        }
        if (token) {
          let finalData = {
            token,
            user_type: "employee",
            status: "2,3",
            isPageSeen: notificationId ? true : false,
            redirectNotificationId: notificationId ? notificationId : "",
          };
          dispatchLeaveAndWFHHistoryListAction(finalData);
        }
      }
    }
  };

  const handleSingleLeaveApply = (data: string) => {
    if (data) {
      let finalData = {
        token,
        employee_availability_id: data,
      };
      dispatchSingleWFHAndLeaveAction(finalData);
    }
  };

  const handleDeleteUpcomingOrApprovedLeave = (type?: string) => {
    setDeleteLeaveToggle(!deleteLeaveToggle);
    if (type) {
      setIsTypeChange(type);
    }
  };

  const handleDeleteLeave = () => {
    if (token) {
      let finalData = {
        token,
        id: isDeleteData?.id,
      };
      dispatchDeleteUpcomingLeave(finalData);
      handleDeleteUpcomingOrApprovedLeave();
    }
  };

  useEffect(() => {
    if (token && isDrawerOpen && (singleLeaveId || isRedirectId)) {
      let finalData = {
        token,
        employee_availability_id:
          isRedirectId && isRedirectId ? isRedirectId : singleLeaveId,
      };
      dispatchSingleWFHAndLeaveAction(finalData);
    } else {
      setSingleLeaveId("");
    }
  }, [isDrawerOpen, singleLeaveId]);

  const openDrawer = () => {
    setIsDrawerOpen(true);
    dispatchResetSingleLeaveAndWFHApplyData();
  };
  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  if (leaveAndWFHHistoryList?.length) {
    leaveAndWFHHistoryList = leaveAndWFHHistoryList?.filter(
      (el: LeaveAndUpcomingHistoryListType) => {
        if (el?.request_status === 3) {
          if (
            new Date(reverseDate(el?.start_date)) <= new Date(currentDate())
          ) {
            return el;
          }
        } else {
          return el;
        }
      }
    );
  }

  if (upcomingList?.length) {
    upcomingList = upcomingList?.filter(
      (el: LeaveAndUpcomingHistoryListType) => {
        if (el?.request_status === 3) {
          if (new Date(reverseDate(el?.start_date)) > new Date(currentDate())) {
            return el;
          }
        } else {
          return el;
        }
      }
    );
  }

  return (
    <div>
      <div className="d-flex align-items-center position-relative">
        <div>
          <CommonHeader title="All Leaves & WFH" />
        </div>
        {/* {upcomingList?.length ? ( */}
        <div style={{ display: "flex" }}>
          <div className="ml-4" style={{ marginTop: "-10px" }}>
            <button
              className="btn btn-primary"
              onClick={() => handleApplyLeave("Leave")}
            >
              Apply Leave
            </button>
          </div>
          {isApplyWFHApplyPresent ? (
            <div className="ml-4" style={{ marginTop: "-10px" }}>
              <button
                className="btn btn-outline"
                onClick={() => handleApplyLeave("WFH")}
              >
                Apply Work From Home
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
        {/*  ) : (
           ""
         )} */}
      </div>

      {/*  first row*/}
      <div
        className="d-flex justift-content-center align-items-center mt-4"
        style={{ gap: "1%" }}
      >
        <div
          className="boxs"
          style={{ width: "62%", height: "363px", overflow: "auto" }}
        >
          {fetching ? (
            <BoxLoader style={{ height: "100%" }} />
          ) : (
            <UpcomingLeaves
              data={upcomingList}
              handleApplyLeave={handleApplyLeave}
              setIsEdit={setIsEdit}
              handleSingleLeaveApply={handleSingleLeaveApply}
              handleDeleteUpcomingLeave={handleDeleteUpcomingOrApprovedLeave}
              setIsDeleteData={setIsDeleteData}
              setApplyLeaveForm={setApplyLeaveForm}
            />
          )}
        </div>
        <div
          className="boxs"
          style={{ width: "36%", height: "363px", position: "relative" }}
        >
          <CurrentYearLeavesAndWFHStatus
            leaveStatus={leaveStatus}
            workFromHomeStatus={workFromHomeStatus}
            isApplyWFHApplyPresent={isApplyWFHApplyPresent}
            activeAction={activeAction}
            setActiveAction={setActiveAction}
          />
          {userProfileAllData?.hr_settings?.employment_status === "Intern" ||
          (userProfileAllData?.hr_settings?.employment_status === "Probation" &&
            activeAction === "leave") ||
          userProfileAllData?.hr_settings?.employment_status === "Part time" ||
          userProfileAllData?.hr_settings?.employment_status === "" ? (
            <div
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                background: "#e1e4e7",
                top: 0,
                opacity: "0.3",
              }}
            ></div>
          ) : (
            ""
          )}
        </div>
      </div>

      <div className="mt-4 boxs">
        <WFHandLeavesHistory
          tableHeader={LEAVE_HISTORYT_HEADERS}
          data={leaveAndWFHHistoryList}
          openDrawer={openDrawer}
          setSingleLeaveId={setSingleLeaveId}
          fetching={fetching}
          isApplyWFHApplyPresent={isApplyWFHApplyPresent}
        />
        {/* {fetching ? (
          <TableLoader Rows={10} ColumnPerRow={6} />
        ) : leaveAndWFHHistoryList?.length ? (
          <LeavesHistoryTable
            tableHeader={LEAVE_HISTORYT_HEADERS}
            data={leaveAndWFHHistoryList}
            openDrawer={openDrawer}
            setSingleLeaveId={setSingleLeaveId}
          />
        ) : (
          !fetching && (
            <div className="p-5 mt-3">
              <EmptyListPage title="No List Found!" imageWidth="30%" />
            </div>
          )
        )} */}
      </div>
      {applyLeaveToggle && (
        <ApplyLeaveModal
          toggle={handleApplyLeave}
          isOpen={applyLeaveToggle}
          applyLeaveForm={applyLeaveForm}
          setApplyLeaveForm={setApplyLeaveForm}
          handleSubmitApplyOrWHF={handleSubmitApplyOrWHF}
          isEdit={isEdit}
          leaveBalance={
            leaveStatus?.balance_leave -
              (leaveStatus?.approved_leave -
                leaveStatus?.full_time_unpaid_approved_leave +
                leaveStatus?.pending_leave) <
            0
              ? 0
              : leaveStatus?.balance_leave -
                (leaveStatus?.approved_leave -
                  leaveStatus?.full_time_unpaid_approved_leave +
                  leaveStatus?.pending_leave)
          }
          workFromHomeStatus={
            workFromHomeStatus?.balance_wfh -
              workFromHomeStatus?.approved_wfh -
              workFromHomeStatus?.pending_wfh <
            0
              ? 0
              : workFromHomeStatus?.balance_wfh -
                workFromHomeStatus?.approved_wfh -
                workFromHomeStatus?.pending_wfh
          }
          weekdays={userProfileAllData?.hr_settings?.working_days}
          singleLeaveApply={singleLeaveApply}
          dateValidation={dateValidation}
          employeeStatus={userProfileAllData?.hr_settings?.employment_status}
          isType={isTypeChange}
        />
      )}

      {deleteLeaveToggle && (
        <DeleteUpcomingLeaves
          toggle={handleDeleteUpcomingOrApprovedLeave}
          isOpen={deleteLeaveToggle}
          isDeleteData={isDeleteData}
          handleDeleteLeave={handleDeleteLeave}
          data={upcomingList}
          isTypeChange={isTypeChange}
        />
      )}
      {handleErrorModal()}
      {fetching && <Loader />}
      <Toaster />
      {isDrawerOpen && (
        <ViewSingleLeaveAndWFHDeatils
          isOpen={isDrawerOpen}
          onClose={closeDrawer}
          fetching={fetching}
          singleData={singleLeaveApply}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  leaveAndWFHHistoryList: state.stcoTools.leaveAndWFHHistoryList,
  upcomingList: state.stcoTools.upcomingList,
  authFetching: state.auth.fetching,
  authSuccess: state.auth.success,
  authError: state.auth.error,
  authStatusCode: state.auth.statusCode,
  totalUserCount: state.auth.totalUserCount,
  allFinacUsersList: state.auth.finacUsersList,
  success: state.stcoTools.success,
  message: state.stcoTools.message,
  error: state.stcoTools.error,
  statusCode: state.stcoTools.statusCode,
  fetching: state.stcoTools.fetching,
  loginData: state.auth.loginData,
  singleLeaveApply: state.stcoTools.singleLeaveAndWFHApplyData,
  leaveStatus: state.stcoTools.leaveStatus,
  workFromHomeStatus: state.stcoTools.workFromHomeStatus,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchLeaveAndWFHHistoryListAction: (data: LeaveAndWFHListPayloadType) =>
    dispatch(getLeaveAndWFHListAction(data)),
  dispatchUpcomingLeaveListAction: (data: LeaveAndWFHListPayloadType) =>
    dispatch(getUpcomingListAction(data)),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchApplyLeaveOrWHFAction: (data: ApplyLeaveFormType) =>
    dispatch(applyLeaveOrWHFAction(data)),
  dispatchUpdateLeaveOrWHFAction: (data: ApplyLeaveFormType) =>
    dispatch(updateApplyLeaveOrWHFAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetStcoToolsSuccess: () => dispatch(resetStcoToolsSuccess()),
  dispatchResetStcoToolsError: () => dispatch(resetStcoToolsError()),
  dispatchResetStcoToolsMessage: () => dispatch(resetStcoToolsMessage()),
  dispatchResetStcoToolsStatusCode: () => dispatch(resetStcoToolsStatusCode()),
  dispatchResetUpcomingLeaveAndWFHList: () =>
    dispatch(resetUpcomingLeaveList()),
  dispatchSingleWFHAndLeaveAction: (data: SingleApplyPayload) =>
    dispatch(getSingleLeaveAction(data)),
  dispatchDeleteUpcomingLeave: (data: DeleteUpcomingLeavePayload) =>
    dispatch(deleteUpcomingLeave(data)),
  dispatchResetSingleLeaveAndWFHApplyData: () =>
    dispatch(resetSingleLeaveAndWFHApplyData()),
});
export default connect(mapStateToProps, mapDispatchToProps)(AllLeavesAndWHF);
